import React from "react";

import { IconProps } from "./../types";
import { BaseSVGIcon } from "./base-svg-icon";

export const SkFlag24: React.FC<IconProps> = (props) => {
  return (
    <BaseSVGIcon width="24" height="24" fill="none" viewBox="0 0 450 300" {...props}>
      <rect width="450" height="300" fill="#fff" />
      <rect width="450" height="200" y="100" fill="#0038a8" />
      <rect width="450" height="100" y="200" fill="#ce1126" />
      <path
        d="M 77.80214,70.519375 C 71.75774,70.977285 73.463095,78.307065 72.713075,82.46923 C 70.581035,111.15021 67.63598,140.75688 76.39564,168.69063 C 83.30531,191.23482 99.81871,209.83941 119.82913,221.838 C 124.75435,224.57723 129.55176,228.01768 134.99952,229.50002 C 140.70281,227.90093 145.74124,224.31012 150.887,221.39337 C 170.58257,209.40799 186.77278,190.9538 193.6034,168.69063 C 202.49837,140.28969 199.33114,110.20194 197.17536,81.05622 C 196.86141,77.045825 197.46604,70.08556 191.54167,70.519375 C 153.62849,70.519375 115.71532,70.519375 77.80214,70.519375 z"
        fill="rgb(255, 255, 255)"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1pt"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity="1"
        id="path19697"
      />
      <g transform="matrix(0.5, 0, 0, 0.5, -4.95224e-05, 150)" id="g1376">
        <g id="g1388">
          <path
            d="M 270.00013,-150.00033 L 270.00013,149.98108 C 131.27111,82.770984 146.4401,-28.549958 155.59324,-150.00033 L 270.00013,-150.00033 z M 270.00013,-150.00033 L 270.00013,149.98108 C 408.72916,82.770984 393.56016,-28.549958 384.40702,-150.00033 L 270.00013,-150.00033 z"
            fill="rgb(206, 17, 38)"
            fillOpacity="1"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1pt"
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeOpacity="1"
            id="path919"
          />
          <g id="g1366">
            <path
              d="M 286.19947,-67.713266 C 300.79888,-67.713266 315.67885,-65.05409 329.99774,-62.219101 C 325.75976,-76.125053 325.75976,-84.622415 329.99774,-98.528367 C 315.67885,-95.693378 300.79888,-93.034202 286.19947,-93.034202 L 253.80076,-93.034202 C 239.20135,-93.034202 224.32138,-95.693378 210.00249,-98.528367 C 214.24047,-84.622415 214.24047,-76.125053 210.00249,-62.219101 C 224.32138,-65.05409 239.20135,-67.713266 253.80076,-67.713266 L 286.19947,-67.713266 z "
              fill="rgb(255, 255, 255)"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1pt"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeOpacity="1"
              id="path3412"
            />
            <path
              d="M 298.79901,-13.082153 C 313.39842,-13.082153 328.27839,-10.422978 342.59728,-7.5879882 C 338.35928,-21.49394 338.35928,-29.991302 342.59728,-43.897254 C 328.27839,-41.062265 313.39842,-38.403089 298.79901,-38.403089 L 241.20127,-38.403089 C 226.60186,-38.403089 211.7219,-41.062265 197.40301,-43.897254 C 201.64099,-29.991302 201.64099,-21.49394 197.40301,-7.5879882 C 211.7219,-10.422978 226.60186,-13.082153 241.20127,-13.082153 L 298.79901,-13.082153 z "
              fill="rgb(255, 255, 255)"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1pt"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeOpacity="1"
              id="path5897"
            />
            <path
              d="M 251.75613,-138.50378 C 254.60434,-124.25132 257.27591,-109.44045 257.27591,-94.908773 L 257.27591,90.87762 L 282.71491,90.87762 L 282.71491,-94.908773 C 282.71491,-109.44043 285.38648,-124.25134 288.23469,-138.50378 C 274.2639,-134.28545 265.72692,-134.28546 251.75613,-138.50378 z "
              fill="rgb(255, 255, 255)"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1pt"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeOpacity="1"
              id="path10868"
            />
            <g
              transform="matrix(1.91992, 0, 0, 1.91101, -89.9903, -1145.43)"
              fill="rgb(0, 56, 168)"
              fillOpacity="1"
              id="g16515"
            >
              <path
                d="M 157.5,623.34375 C 148.93543,623.34375 142,630.27919 142,638.84375 C 142,639.49669 142.10906,640.11818 142.1875,640.75 C 145.17278,645.1791 148.66482,649.42813 152.6875,653.53125 C 154.21295,654.03309 155.80728,654.375 157.5,654.375 C 166.06457,654.375 173.03125,647.40831 173.03125,638.84375 C 173.03125,630.27919 166.06457,623.34375 157.5,623.34375 z "
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1pt"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeOpacity="1"
                id="path13976"
              />
              <path
                d="M 187.5,614.1875 C 176.61185,614.1875 167.78125,623.04937 167.78125,633.9375 C 167.78125,644.82564 176.61186,653.65622 187.5,653.65625 C 198.38815,653.65625 207.21874,644.82564 207.21875,633.9375 C 207.21875,623.04936 198.38815,614.18747 187.5,614.1875 z "
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1pt"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeOpacity="1"
                id="path15884"
              />
              <path
                d="M 217.5,623.34375 C 208.93543,623.34375 202,630.27919 202,638.84375 C 202,647.40831 208.93544,654.375 217.5,654.375 C 219.19272,654.375 220.78705,654.03309 222.3125,653.53125 C 226.34603,649.41706 229.85303,645.16064 232.84375,640.71875 C 232.9197,640.09681 233.03125,639.48609 233.03125,638.84375 C 233.03125,630.27919 226.06458,623.34375 217.5,623.34375 z "
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1pt"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeOpacity="1"
                id="path15882"
              />
              <path
                d="M 144.625,644.125 C 154.09998,656.84337 167.7248,668.24983 187.5,677.875 C 207.27521,668.24983 220.90002,656.84337 230.375,644.125 L 144.625,644.125 z "
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1pt"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeOpacity="1"
                id="path15876"
              />
            </g>
          </g>
        </g>
      </g>
    </BaseSVGIcon>
  );
};
